var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.optionList)?_c('v-autocomplete',{attrs:{"disabled":_vm.disabled,"items":_vm.optionList,"rules":_vm.ruleList,"outlined":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_c('p',[_vm._v("No subcategories for this item!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }